// eslint:disable max-func-body-length
import * as React from 'react';
import { OptionsProps } from 'app/components/options-handler';
import { ExtraInfo } from 'app/components/access-panel';
import { Component } from 'react';
import { withMetroLine } from 'app/components/metro-line/with-metro-line';
import { WithMetroLineProps, WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { simpleFieldForPath } from 'app/infrastructure/simple-form';
import { AdministrationEditTranslation } from 'app/area/administration/edit/constants';
import { STATE } from 'app/constants';
import { RoleEditSectionType, AdministrationRoleEditProps } from 'app/area/administration/edit/role/types';
import { Details } from 'app/area/administration/edit/role/details';
import { roleOptions } from '../endpoints';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ComplexValue } from 'ui/common/types';
import {
  PanelsProps, Operation, DefaultValues, AccessToScreen, ExtendedAccess,
  UserOccurence, RestrictedAccess
} from 'app/components/access-panel';
import { ApiToUse } from 'app/infrastructure/simple-form/types';
import { AdminPaperTopPanel } from 'app/area/administration/edit/components';

interface RoleEditFormExternalProps extends WithMetroLineProps<RoleEditSectionType> {
  translation: AdministrationEditTranslation;
  clearValidation: (formName: string, parameters?: { [key: string]: number | string }) => void;
}

const SimpleForm = simpleFieldForPath(STATE.administrationRoleEdit);

export type RoleEditFormComponentProps = AdministrationRoleEditProps & RoleEditFormExternalProps & OptionsProps
  & WithMetroLineProps<RoleEditSectionType> & WithMetroLineWrappedComponentProps<RoleEditSectionType>;

export class RoleEditFormComponent extends Component<RoleEditFormComponentProps> {

  private isValueFieldsReadOnly = (optionsColection: ComplexValue<number>, caseType: ComplexValue<number>) => {
    return !optionsColection || !caseType;
  };

  public render() {
    const { data, editMode, formValues, validation, clearValueInStore, clearValidation,
      accessData, updateAccessData, translation, personOptionsCodes,
      options, loadOptions, markedAsDefaultRole, changeDefaultRoleMark,
      sharedState: {
        access: {
          adminPanel: {
            restrictedAccessPanel
          }
        }
      }
    } = this.props;

    const panelProps: PanelsProps = {
      readOnly: !editMode,
      translation,
      formComponent: SimpleForm,
      formValues,
      validation,
      clearValueInStore,
      endpoints: roleOptions,
      data,
      roleSelected: false,
      roleBasedData: undefined,
      fetchingRoleBasedData: false,
      accessData,
      updateAccessData,
      clearValidation,
      personOptionsCodes,
      options,
      loadOptions
    };

    return <div>
      <MetroLineSection<RoleEditSectionType>
        {...this.props}
        sectionType={RoleEditSectionType.Details}>
        <Details
          changeDefaultRoleMark={changeDefaultRoleMark}
          markedAsDefaultRole={markedAsDefaultRole}
          data={data}
          readOnly={!editMode}
          formComponent={SimpleForm}
          translation={translation}
        />
        <ExtraInfo
          readOnly={!editMode}
          formComponent={SimpleForm}
          roleSelected={false}
          roleBasedData={undefined}
          fetchingRoleBasedData={false}
          endpoints={roleOptions}
          {...this.props}
        />

      </MetroLineSection>

      <MetroLineSection<RoleEditSectionType>
        {...this.props}
        sectionType={RoleEditSectionType.AccessToOperation}>
        <Operation {...panelProps} />
      </MetroLineSection>

      <MetroLineSection<RoleEditSectionType>
        {...this.props}
        sectionType={RoleEditSectionType.DefaultValues}>
        {<AdminPaperTopPanel title={translation.default_values}>
          <DefaultValues
            apiToUse={ApiToUse.ADMINAPI}
            isValueFieldsReadOnly={this.isValueFieldsReadOnly}
            isUserTypeRequired={false}
            fieldsOptionParams={{ includeOptionsForAllUserTypes: true }}
            {...panelProps} />
        </AdminPaperTopPanel>}
      </MetroLineSection>

      <MetroLineSection<RoleEditSectionType>
        {...this.props}
        sectionType={RoleEditSectionType.AccessToScreen}>
        <AccessToScreen {...panelProps} />
      </MetroLineSection>

      <MetroLineSection<RoleEditSectionType>
        {...this.props}
        sectionType={RoleEditSectionType.ExtendedAccess}>
        <ExtendedAccess {...panelProps} />
      </MetroLineSection>

      <MetroLineSection<RoleEditSectionType>
        {...this.props}
        sectionType={RoleEditSectionType.RestrictedAccess}>
        {restrictedAccessPanel && <RestrictedAccess {...panelProps} />}
      </MetroLineSection>

      <MetroLineSection<RoleEditSectionType>
        {...this.props}
        sectionType={RoleEditSectionType.UserOccurence}>
        <UserOccurence {...panelProps} />
      </MetroLineSection>
    </div>;
  }
}

export const RoleEditForm = withMetroLine<RoleEditFormExternalProps, RoleEditSectionType>()(RoleEditFormComponent);
